import React from "react";

function RadioButtonAnswers({ questionId, answers, onChange }) {
  return (
    <div className="radio-answers">
      {answers.map((answer) => (
        <div key={answer.id} className={`answer-option${answer.checked ? " checked" : ""}`}>
          <input
            type="radio"
            name={questionId}
            value={answer.id}
            id={`answer-${answer.id}`}
            checked={!!answer.checked}
            onChange={() => onChange(questionId, answer.id, "radio")}
          />
          <label className="answer-option-radio-btn" htmlFor={`answer-${answer.id}`}>
            {answer.text}
          </label>
        </div>
      ))}
    </div>
  );
}

export default RadioButtonAnswers;
